<template>
  <confirm-modal />
  <form
    v-if="isInterview"
    @submit.prevent
  >
    <div
      v-if="!isOnlyConsulting"
      class="card my-5"
    >
      <div class="row align-items-center justify-content-between">
        <div class="card-title col-auto mb-3">
          <img
            v-if="!subscriptionPlansVisible"
            src="~@/assets/img/chevron-down-solid.svg"
            alt="Futuro | Consultoria Financeira"
            @click="subscriptionPlansVisible = !subscriptionPlansVisible"
          >
          <img
            v-if="subscriptionPlansVisible"
            src="~@/assets/img/chevron-up-solid.svg"
            alt="Futuro | Consultoria Financeira"
            @click="subscriptionPlansVisible = !subscriptionPlansVisible"
          >
          <h2>Pacote de acompanhamento</h2>
        </div>
        <spinner
          v-if="loading"
          class="mr-2"
        />
      </div>
      <div
        v-if="subscriptionPlansVisible"
        class="row container-plans"
      >
        <div class="plans-pager">
          <button
            v-if="currentPlanPage > 0"
            type="button"
            class="plan-nav-arrow plan-nav-arrow-left"
            aria-label="Página anterior"
            @click="currentPlanPage--"
          >
            ‹
          </button>

          <div class="plans-page-track">
            <template
              v-for="plan in currentPagePlans"
              :key="plan.id"
            >
              <article
                class="d-flex flex-column align-items-center position-relative"
                @click="setSubscription(plan)"
              >
                <div
                  v-if="plan.most_chosen"
                  class="card-head-best-choice w-100"
                >
                  <h5>Mais escolhido</h5>
                  <div class="bg-star">
                    <img
                      src="@/assets/img/star-best-choice.svg"
                      alt="mais-escolhido"
                    >
                  </div>
                </div>
                <div
                  class="card-plans"
                  :class="{
                    'best-choice-border': plan.most_chosen,
                    'selected-plan-card': subscriptionPlanId === plan.id,
                    clickable: !isDetail,
                  }"
                >
                  <div class="card-title">
                    <h3 class="card-font">
                      {{ plan.name }}
                    </h3>
                  </div>
                  <div
                    v-if="plan.id === subscriptionPlanTypes.SUPORTE"
                    class="card-divider"
                  />
                  <!-- <p class="card-subtitle">com Open Finance + Open Invest</p> -->
                  <div class="card-price">
                    <h1 class="card-font">
                      <template v-if="plan.id === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM && plan.amount === 0">
                        A combinar
                      </template>
                      <template v-else>
                        {{ formatCurrency(plan.amount, "BRL") }}
                      </template>
                      <p>/ mês</p>
                    </h1>
                  </div>
                  <div
                    :set="
                      (planMetadata = JSON.parse(
                        plan.financial_solution.metadata || '{}'
                      ))
                    "
                    class="card-description"
                  >
                    <div
                      class="card-detail"
                      :class="{
                        'not-included': [
                          subscriptionPlanTypes.FLUXO,
                          subscriptionPlanTypes.APP,
                        ].includes(plan.id),
                      }"
                    >
                      <img
                        v-if="
                          ![
                            subscriptionPlanTypes.FLUXO,
                            subscriptionPlanTypes.APP,
                          ].includes(plan.id)
                        "
                        src="@/assets/img/correct.svg"
                        alt="Incluso"
                      >
                      <img
                        v-else
                        src="@/assets/img/wrong.svg"
                        alt="Não incluso"
                      >
                      <span>Plano financeiro</span>
                    </div>
                    <div
                      class="card-detail"
                      :class="{
                        'not-included': plan.id === subscriptionPlanTypes.APP,
                      }"
                    >
                      <img
                        v-if="plan.id !== subscriptionPlanTypes.APP"
                        src="@/assets/img/correct.svg"
                        alt="Incluso"
                      >
                      <img
                        v-else
                        src="@/assets/img/wrong.svg"
                        alt="Não incluso"
                      >
                      <span>Suporte ilimitado pelo Whatsapp</span>
                    </div>
                    <div
                      class="card-detail"
                      :class="{
                        'not-included': !planMetadata.ead_access,
                      }"
                    >
                      <img
                        v-if="planMetadata.ead_access"
                        src="@/assets/img/correct.svg"
                        alt="Incluso"
                      >
                      <img
                        v-else
                        src="@/assets/img/wrong.svg"
                        alt="Não incluso"
                      >
                      <span>Escola de negócios</span>
                    </div>
                    <div
                      class="card-detail"
                      :class="{
                        'not-included': !planMetadata.workshops,
                      }"
                    >
                      <img
                        v-if="planMetadata.workshops"
                        src="@/assets/img/correct.svg"
                        alt="Incluso"
                      >
                      <img
                        v-else
                        src="@/assets/img/wrong.svg"
                        alt="Não incluso"
                      >
                      <span>Workshop ao vivo</span>
                    </div>
                    <div
                      class="card-detail"
                      :class="{
                        'not-included': !planMetadata.benefits_club,
                      }"
                    >
                      <img
                        v-if="planMetadata.benefits_club"
                        src="@/assets/img/correct.svg"
                        alt="Incluso"
                      >
                      <img
                        v-else
                        src="@/assets/img/wrong.svg"
                        alt="Não incluso"
                      >
                      <span>Clube de descontos</span>
                    </div>
                    <div
                      class="card-detail"
                      :class="{
                        'not-included': !planMetadata.app,
                      }"
                    >
                      <img
                        v-if="planMetadata.app"
                        src="@/assets/img/correct.svg"
                        alt="Incluso"
                      >
                      <img
                        v-else
                        src="@/assets/img/wrong.svg"
                        alt="Não incluso"
                      >
                      <span>{{ planMetadata.app }}</span>
                    </div>
                    <div
                      class="card-detail"
                      :class="{
                        'not-included': !planMetadata.meetings,
                      }"
                    >
                      <template v-if="planMetadata.meetings">
                        <img
                          src="@/assets/img/correct.svg"
                          alt="Incluso"
                        >
                        <span v-html="planMetadata.meetings" />
                      </template>
                      <template v-else>
                        <img
                          src="@/assets/img/wrong.svg"
                          alt="Não incluso"
                        >
                        <span>Não existem reuniões neste plano</span>
                      </template>
                    </div>

                    <template
                      v-if="
                        plan.id === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM &&
                          customerSubscriptionPlans.premium_benefits &&
                          customerSubscriptionPlans.premium_benefits.length
                      "
                    >
                      <div
                        v-for="(benefit, idx) in customerSubscriptionPlans.premium_benefits"
                        :key="idx"
                        class="card-detail"
                      >
                        <img
                          src="@/assets/img/correct.svg"
                          alt="Incluso"
                        >
                        <span>{{ benefit }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </article>
            </template>
          </div>

          <button
            v-if="currentPlanPage < planPages.length - 1"
            type="button"
            class="plan-nav-arrow plan-nav-arrow-right"
            aria-label="Próxima página"
            @click="currentPlanPage++"
          >
            ›
          </button>
        </div>

        <div
          v-if="planPages.length > 1"
          class="plans-page-dots"
        >
          <button
            v-for="(_, idx) in planPages"
            :key="idx"
            type="button"
            class="plan-page-dot"
            :class="{ active: idx === currentPlanPage }"
            :aria-label="`Página ${idx + 1}`"
            @click="currentPlanPage = idx"
          />
        </div>

        <!-- Campo de valor do Acompanhamento Premium -->
        <div
          v-if="subscriptionPlanId === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM && !isDetail"
          class="premium-amount-section"
        >
          <h4 class="premium-amount-title">
            Valor mensal do Acompanhamento Premium
          </h4>
          <p class="premium-amount-hint">
            O valor mínimo para o Acompanhamento Premium é de R$ 399,90 por mês.
          </p>
          <div class="row justify-content-center">
            <div class="col-md-4 col-12">
              <input
                ref="premiumInput"
                v-model.lazy="premiumAmountInput"
                v-money="moneyFormat"
                type="text"
                class="form-control premium-amount-input"
                :class="{ 'is-invalid': premiumAmountError }"
                @input="onPremiumInput"
                @blur="onPremiumBlur"
              >
              <div
                v-if="premiumAmountError"
                class="invalid-feedback"
              >
                {{ premiumAmountError }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card my-5"
      :class="{ 'error-bg': v$.recommendations.$invalid }"
    >
      <div class="row align-items-center justify-content-between">
        <div class="card-title col-auto mb-3">
          <img
            src="~@/assets/img/ic-like.svg"
            alt="Futuro | Consultoria Financeira"
          >
          <h2>Transforme futuros e ganhe</h2>
        </div>
        <spinner
          v-if="loading"
          class="mr-2"
        />
      </div>
      <div class="row mt-5 px-3">
        <div class="col-md-3 col-6 text-center d-flex flex-column">
          <span class="mb-2"> 0 a 9 = 0% </span>
          <div
            class="recommendation-discount-value"
            :class="{
              selected: recommendationDiscount === 0,
              clickable:
                !isDetail ||
                (calculation &&
                  calculation.discount_value_0 &&
                  calculation &&
                  calculation.discount_value_0.active),
            }"
            @click="setRecommendationDiscount(0, true)"
          >
            +
            {{
              formatCurrency(
                calculation && calculation.discount_value_0
                  ? calculation.discount_value_0.discount
                  : 0,
                "BRL"
              )
            }}
          </div>
        </div>
        <div class="col-md-3 col-6 text-center d-flex flex-column">
          <span class="mb-2"> 10 a 19 = 5% </span>
          <div
            class="recommendation-discount-value"
            :class="{
              selected: recommendationDiscount === 5,
              clickable:
                !isDetail ||
                (calculation &&
                  calculation.discount_value_5 &&
                  calculation &&
                  calculation.discount_value_5.active),
            }"
            @click="setRecommendationDiscount(5, true)"
          >
            +
            {{
              formatCurrency(
                calculation && calculation.discount_value_5
                  ? calculation.discount_value_5.discount
                  : 0,
                "BRL"
              )
            }}
          </div>
        </div>
        <div class="col-md-3 col-6 text-center d-flex flex-column">
          <span class="mb-2"> 20 a 29 = 7.5% </span>
          <div
            class="recommendation-discount-value"
            :class="{
              selected: recommendationDiscount === 7.5,
              clickable:
                !isDetail ||
                (calculation &&
                  calculation.discount_value_7_5 &&
                  calculation &&
                  calculation.discount_value_7_5.active),
            }"
            @click="setRecommendationDiscount(7.5, true)"
          >
            +
            {{
              formatCurrency(
                calculation && calculation.discount_value_7_5
                  ? calculation.discount_value_7_5.discount
                  : 0,
                "BRL"
              )
            }}
          </div>
        </div>
        <div class="col-md-3 col-6 text-center d-flex flex-column">
          <span class="mb-2"> acima de 30 = 10% </span>
          <div
            class="recommendation-discount-value"
            :class="{
              selected: recommendationDiscount === 10,
              clickable:
                !isDetail ||
                (calculation &&
                  calculation.discount_value_10 &&
                  calculation &&
                  calculation.discount_value_10.active),
            }"
            @click="setRecommendationDiscount(10, true)"
          >
            +
            {{
              formatCurrency(
                calculation && calculation.discount_value_10
                  ? calculation.discount_value_10.discount
                  : 0,
                "BRL"
              )
            }}
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div
          id="recommendationsSection"
          class="col-12"
        >
          <h2>Recomendações</h2>
        </div>
      </div>
      <div
        v-for="(recommendation, index) in recommendations"
        :key="`recommendation-${index}`"
        class="inner-card mt-3"
        style="padding: 20px"
      >
        <div class="row mb-2">
          <div class="col-12">
            <h2>
              <span style="float: left">#{{ index + 1 }}</span>
              <span style="float: right">{{
                $filters.leadType(recommendation.type)
              }}</span>
            </h2>
          </div>
        </div>
        <div class="row justify-content-around">
          <div class="col-md-2 col-12 mb-3 mb-md-0">
            <label
              :for="`recommendationName-${index}`"
              class="form-label"
            >
              Nome
            </label>
            <input
              :id="`recommendationName-${index}`"
              v-model="recommendation.name"
              type="text"
              class="form-control"
              :disabled="isDetail"
              :class="{
                'is-invalid':
                  v$.recommendations.$dirty &&
                  v$.recommendations.$each.$response.$errors[index].name.length,
              }"
              @blur="autoSaveRecommendations()"
            >

            <div class="invalid-feedback">
              <span
                v-if="
                  v$.recommendations.$dirty &&
                    v$.recommendations.$each.$response.$errors[index].name.length
                "
              >
                Nome inválido
              </span>
            </div>
          </div>
          <div class="col-md-2 col-12 mb-3 mb-md-0">
            <label
              :for="`recommendationCellPhone-${index}`"
              class="form-label"
            >
              Celular
            </label>
            <input
              :id="`recommendationCellPhone-${index}`"
              v-model="recommendation.cellPhone"
              v-mask="'+## ## # #### ####'"
              type="text"
              :disabled="isDetail || loadingProposal"
              class="form-control"
              :class="{
                'is-invalid':
                  (v$.recommendations.$dirty &&
                    v$.recommendations.$each.$response.$errors[index].cellPhone
                      .length) ||
                  recommendation.duplicateError,
              }"
              @input="checkCellPhone(recommendation, index)"
              @blur="autoSaveRecommendations()"
            >

            <div class="invalid-feedback">
              <span
                v-if="
                  v$.recommendations.$dirty &&
                    v$.recommendations.$each.$response.$errors[index].cellPhone
                      .length
                "
              >
                Celular inválido
              </span>
              <span v-if="recommendation.duplicateError">Celular já existe</span>
            </div>
          </div>
          <div class="col-md-2 col-12 mb-3 mb-md-0">
            <label
              :for="`recommendationOccupation-${index}`"
              class="form-label"
            >
              Profissão
            </label>
            <input
              :id="`recommendationOccupation-${index}`"
              v-model="recommendation.occupation"
              type="text"
              :disabled="isDetail || loadingProposal"
              class="form-control"
              @blur="autoSaveRecommendations()"
            >
          </div>
          <div class="col-md-2 col-12 mb-3 mb-md-0">
            <label
              :for="`recommendationGoal-${index}`"
              class="form-label"
            >
              Objetivo
            </label>
            <select
              :id="`recommendationGoal-${index}`"
              v-model="recommendation.goal"
              :disabled="isDetail || loadingProposal"
              class="form-select"
              :class="{ 'select-disabled': isDetail }"
              @blur="autoSaveRecommendations()"
            >
              <option
                v-for="goal_key in Object.keys(goals)"
                :key="goal_key"
                :value="goal_key"
              >
                {{ goals[goal_key] }}
              </option>
            </select>
          </div>
          <div class="col-auto d-flex align-items-center">
            <template v-if="!isDetail">
              <div class="d-flex flex-row">
                <button
                  v-if="recommendation.id === ''"
                  class="btn btn-red margin-button"
                  type="button"
                  :disabled="loadingProposal"
                  @click.prevent="removeRecWhenFieldsEmpty(index)"
                >
                  Excluir
                </button>
                <button
                  v-else
                  class="btn btn-red margin-button"
                  type="button"
                  :disabled="loadingProposal"
                  @click.prevent="openConfimationModal(recommendation)"
                >
                  Excluir
                </button>
              </div>
            </template>
          </div>
          <div class="col-12 mt-3 px-5">
            <label
              :for="`recommendationComment-${index}`"
              class="form-label"
            >
              Observação
            </label>
            <textarea
              :id="`recommendationComment-${index}`"
              v-model="recommendation.comment"
              :disabled="isDetail || loadingProposal"
              class="form-control recommendation-comment-field"
              rows="3"
              @blur="autoSaveRecommendations()"
            />
          </div>
          <div
            :class="'col-12 mt-2 d-flex justify-content-start align-items-center'"
            :style="!loadingRecs ? 'margin: 10px 0;' : ''"
          >
            <spinner
              v-if="loadingRecs"
              size="small"
              style="margin-right: 0.25rem"
            />
            <span>{{ loadingRecs ? "Registrando informações..." : "" }}</span>
          </div>
        </div>
      </div>
      <div class="row align-items-center px-4 mt-4 justify-content-between">
        <template v-if="!isDetail">
          <div class="d-flex justify-content-between p-0 column-mobile">
            <div class="d-flex">
              <button
                class="btn btn-orange col-auto mx-1"
                :class="{ 'btn-white-full': v$.recommendations.$invalid }"
                type="button"
                :disabled="loadingProposal"
                @click.prevent="addRecommendation('PCL')"
              >
                Adicionar rec. cliente
              </button>
              <button
                class="btn btn-orange col-auto mx-1"
                :class="{ 'btn-white-full': v$.recommendations.$invalid }"
                type="button"
                :disabled="loadingProposal"
                @click.prevent="addRecommendation('PPN')"
              >
                Adicionar rec. PN
              </button>
            </div>

            <button
              class="btn btn-orange col-auto mb-2 mb-md-0"
              type="button"
              :disabled="loadingProposal"
              @click.prevent="saveRecommendation"
            >
              {{ loadingProposal ? "Salvando..." : "Salvar propostas" }}
            </button>
          </div>
        </template>
      </div>
      <div class="row mt-5 mb-3">
        <div class="col-12">
          <h2>Exclusivo para o PN</h2>
        </div>
      </div>
      <div class="row mb-3 align-items-center">
        <div class="col-md-6 col-12">
          <label
            for="servicesToContract"
            class="form-label"
          >
            Serviços a contratar
          </label>
          <select
            id="servicesToContract"
            v-model="servicesToContract"
            :disabled="isDetail"
            class="form-select"
            :class="{
              'is-invalid': v$.servicesToContract.$error,
              'select-disabled': isDetail,
            }"
            @change="preSave()"
          >
            <option
              v-for="key in Object.keys(contractServiceTypes)"
              :key="key"
              :value="key"
              :disabled="isServicesToContractOptionDisabled(key)"
            >
              <span>
                {{
                  contractServiceTypes[key].replace(
                    "assinatura",
                    subscriptionName
                  )
                }}
              </span>
            </option>
          </select>
          <div class="invalid-feedback">
            <span v-if="v$.servicesToContract.required.$invalid">
              Você deve selecionar uma opção
            </span>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <label
            for="supportFromAnotherConsultant"
            class="form-label"
          >
            Houve auxílio de um PN (closer)?
          </label>
          <select
            id="supportFromAnotherConsultant"
            v-model="supportFromAnotherConsultant"
            class="form-select"
            :disabled="isDetail"
            :class="{ 'select-disabled': isDetail }"
            @blur="preSave()"
          >
            <option value="yes">
              Sim
            </option>
            <option
              value="no"
              :disabled="isAnalyst"
            >
              Não
            </option>
          </select>
        </div>
        <div class="col-md-6 col-12 mt-3 partner-signer-column">
          <label
            for="partnerAsSigner"
            class="form-label"
          >
            Contrato com dois assinantes
          </label>
          <label
            class="partner-signer-toggle"
            :class="{ disabled: isDetail || !canEnablePartnerAsSigner }"
            for="partnerAsSigner"
          >
            <input
              id="partnerAsSigner"
              v-model="partnerAsSigner"
              class="partner-signer-checkbox"
              type="checkbox"
              :disabled="isDetail || !canEnablePartnerAsSigner"
              @change="preSave()"
            >
            <span>
              Incluir conjuge/parceiro como segundo assinante
            </span>
          </label>
          <small
            v-if="!canEnablePartnerAsSigner && !isDetail"
            class="partner-signer-hint"
          >
            Preencha nome e e-mail do conjuge/parceiro para habilitar essa opcao.
          </small>
        </div>
        <div
          v-if="supportFromAnotherConsultant === 'yes'"
          class="col-md-6 col-12 mt-3"
        >
          <label
            for="closerConsultantId"
            class="form-label"
          >
            PN especialista
          </label>
          <select
            id="closerConsultantId"
            v-model="closerConsultantId"
            :disabled="isDetail"
            class="form-select"
            :class="{
              'is-invalid': v$.closerConsultantId.$error,
              'select-disabled': isDetail,
            }"
            @blur="preSave()"
          >
            <option
              v-for="consultant in closerConsultants"
              :key="consultant.id"
              :value="consultant.id"
            >
              {{ consultant.name }}
            </option>
          </select>
          <div class="invalid-feedback">
            <span v-if="v$.closerConsultantId.required.$invalid">
              Você deve selecionar uma opção
            </span>
          </div>
        </div>
      </div>
      <comments-section
        v-if="interviewSection && token"
        :interview-section="interviewSection"
        :token="token"
      />
    </div>
  </form>
</template>

<script>
import _ from "lodash";
import useVuelidate from "@vuelidate/core";
import {
  helpers,
  required,
  email,
  requiredIf,
  minLength,
} from "@vuelidate/validators";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getProposalPayload } from "@/helpers/interview_payloads";
import { getPercentageFormat } from "@/helpers/formatting";
import * as types from "../store/types";
import * as accountTypes from "@/modules/account/store/types";
import * as sharedTypes from "@/modules/shared/store/types";
import { floatToPercentage, percentageToFloat } from "@/helpers/converters";
import Spinner from "@/modules/shared/components/Spinner";
import CommentsSection from "./CommentsSection";
import Presentation from "@/modules/shared/components/Presentation";
import SubscriptionPlans from "./SubscriptionPlans";
import ConfirmModal from "@/modules/shared/components/ConfirmModal";
import * as subscriptionPlanTypes from "@/constants/subscriptionPlanTypes";
import { PREMIUM_MINIMUM_AMOUNT } from "@/constants/subscriptionPlanTypes";
import { isBackofficeRole } from "@/constants/auth";
import { getBRLFormat } from "@/helpers/formatting";
import { floatToMoney, moneyToFloat } from "@/helpers/converters";

export default {
  components: {
    Spinner,
    CommentsSection,
    Presentation,
    SubscriptionPlans,
    ConfirmModal,
  },
  props: {
    interviewSection: {
      type: String,
      default: "",
    },
    isInterview: {
      type: Boolean,
      default: false,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    externalParcels: {
      type: Object,
      default: null,
    },
  },
  emits: ['closer-consultant-change'],
  setup(props) {
    const parcels = _.range(2, 13);

    return {
      parcels,
      v$: useVuelidate({ $registerAs: props.interviewSection }),
    };
  },
  data() {
    return {
      selectedParcel: 12,
      parcelsQuantity: 1,
      recommendations: [],
      interest: 0,
      totalAmount: 0,
      installmentAmount: 0,
      consultantId: undefined,
      userConsultantId: undefined,
      discount: 0,
      recommendationDiscount: 0,
      servicesToContract: "consulting_and_subscription",
      partnerAsSigner: false,
      hasPartnerInfoForSignature: false,
      paymentMethod: "",
      supportFromAnotherConsultant: "no",
      closerConsultantId: undefined,
      token: "",
      subscriptionPlanId: undefined,
      premiumAmount: 0,
      premiumAmountInput: "",
      premiumAmountError: "",
      loading: false,
      subscriptionPlansVisible: false,
      ownerLevel: undefined,
      loadingProposal: false,
      loadingRecs: false,
      pendingPhoneChecks: [],
      onlySubscriptionKey: "only_subscription",
      investmentPercentage: "",
      discountPercentage: "",
      additionPercentage: "",
      currentPlanPage: 0,
      isInitializing: true,
      tempPayload: null,
      premiumDebounceTimer: null,
    };
  },
  validations() {
    return {
      selectedParcel: {},
      parcelsQuantity: {},
      recommendations: {
        $each: helpers.forEach({
          id: {},
          name: { required },
          cellPhone: {
            minLength(value) {
              if (!value) {
                return true;
              } else {
                var trimmed = value.replace("+", "").replaceAll(" ", "");
                return trimmed.length >= 13;
              }
            },
          },

          email: { email },
          occupation: {},
          goal: {},
          comment: {},
          type: {},
        }),
        recommendationCellErrors(value) {
          return !value.some((rec) => rec.duplicateError);
        },
      },
      servicesToContract: { required },
      closerConsultantId: {
        required: requiredIf(function () {
          return this.supportFromAnotherConsultant === "yes";
        }),
      },
      investmentPercentage: {
        minLength: minLength(7),
      },
      discountPercentage: {
        minLength: minLength(7),
        outOfBounds: function (value) {
          const convertedValue = percentageToFloat(value);
          return convertedValue >= 0 && convertedValue <= 30;
        },
      },
      additionPercentage: {
        minLength: minLength(7),
      },
    };
  },
  computed: {
    ...mapGetters({
      goals: types.GOALS,
      contractServiceTypes: types.CONTRACT_SERVICE_TYPES,
      paymentMethodTypes: types.PAYMENT_METHOD_TYPES,
      closerConsultants: types.CLOSER_CONSULTANTS,
      calculation: types.PROPOSAL_CALCULATION,
      isAnalyst: accountTypes.IS_HUNTER,
      isPn: accountTypes.IS_PN,
      user: accountTypes.USER,
      subscriptionPlans: types.SUBSCRIPTION_PLANS,
      customerSubscriptionPlans: types.CUSTOMER_SUBSCRIPTION_PLANS,
      customerInfo: types.CUSTOMER_INFO,
      formatCurrency: types.FORMAT_CURRENCY,
      proposalPercentages: types.PROPOSAL_PERCENTAGES,
    }),
    isOnlyConsulting() {
      return this.servicesToContract === 'only_consulting';
    },
    isOnlySubscription() {
      return this.servicesToContract === this.onlySubscriptionKey;
    },
    payments: function () {
      if (!this.paymentMethodTypes) return {};
      return Object.fromEntries(
        Object.entries(this.paymentMethodTypes).filter(
          ([key, value]) =>
            this.parcelsQuantity === 1 ||
            (this.parcelsQuantity > 1 && key === "credit")
        )
      );
    },
    filteredSubscriptionPlans() {
      const plans = this.subscriptionPlans
        ?.filter((plan) => this.customerPlans.includes(plan.id))
        .map((plan) => {
          if (plan.id === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM && this.premiumAmount > 0) {
            return { ...plan, amount: this.premiumAmount };
          }
          return plan;
        });

      if (!plans) return [];

      // Ordem fixa: Suporte → Básico → Essencial → Elite → Premium (outros por order)
      const planOrder = [
        subscriptionPlanTypes.SUPORTE,
        subscriptionPlanTypes.BASICO,
        subscriptionPlanTypes.ESSENCIAL,
        subscriptionPlanTypes.ELITE,
        subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM,
      ];

      return [...plans].sort((a, b) => {
        const ia = planOrder.indexOf(a.id);
        const ib = planOrder.indexOf(b.id);
        if (ia === -1 && ib === -1) return (a.order ?? 0) - (b.order ?? 0);
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
    },
    planPageOneIds() {
      return [
        subscriptionPlanTypes.SUPORTE,
        subscriptionPlanTypes.BASICO,
        subscriptionPlanTypes.ESSENCIAL,
        subscriptionPlanTypes.ELITE,
      ];
    },
    planPages() {
      const pageOneIds = this.planPageOneIds;
      const page1 = this.filteredSubscriptionPlans.filter((plan) =>
        pageOneIds.includes(plan.id)
      );
      const page2 = this.filteredSubscriptionPlans.filter(
        (plan) => !pageOneIds.includes(plan.id)
      );
      return [page1, page2].filter((page) => page.length);
    },
    currentPagePlans() {
      return this.planPages[this.currentPlanPage] || [];
    },
    differentConsultant: function () {
      return this.userConsultantId != this.consultantId && !this.isAnalyst && !this.isBackoffice;
    },
    canEnablePartnerAsSigner() {
      const hasCustomerInfo =
        this.customerInfo && Object.keys(this.customerInfo).length > 0;
      if (hasCustomerInfo) {
        const hasPartner = Boolean(this.customerInfo.has_partner);
        const hasPartnerName = Boolean(
          (this.customerInfo.partner_name || "").trim()
        );
        const hasPartnerEmail = Boolean(
          (this.customerInfo.partner_email || "").trim()
        );

        return hasPartner && hasPartnerName && hasPartnerEmail;
      }

      return this.hasPartnerInfoForSignature;
    },
    plansPresentationUrl: function () {
      return process.env.VUE_APP_SUBSCRIPTION_PLANS_CANVA_PRESENTATION;
    },
    subscriptionName: function () {
      return (
        _.find(this.subscriptionPlans, { id: this.subscriptionPlanId })?.name ||
        "Assinatura"
      );
    },
    customerPlans: function () {
      const base = this.customerSubscriptionPlans?.subscription_plans_id || [
        subscriptionPlanTypes.SUPORTE,
        subscriptionPlanTypes.BASICO,
        subscriptionPlanTypes.ESSENCIAL,
        subscriptionPlanTypes.ELITE,
        subscriptionPlanTypes.FLUXO,
        subscriptionPlanTypes.APP,
      ];
      // Premium sempre disponível na Entrevista
      if (!base.includes(subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM)) {
        return [...base, subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM];
      }
      return base;
    },
    moneyFormat() {
      return getBRLFormat();
    },
    subscriptionPlanTypes() {
      return subscriptionPlanTypes;
    },

    discount0: function () {
      return this.calculation?.discount_value_0 || 0;
    },
    discount5: function () {
      return this.calculation?.discount_value_5 || 0;
    },
    discount10: function () {
      return this.calculation?.discount_value_7_5 || 0;
    },

    discount15: function () {
      return this.calculation?.discount_value_10 || 0;
    },
    percentageFormat: function () {
      return getPercentageFormat();
    },
    breakpoints() {
      return {
        768: {
          slidesPerView: 1.5,
        },
        992: {
          slidesPerView: 2.5,
        },
        1200: {
          slidesPerView: 3,
        },
        1400: {
          slidesPerView: this.subscriptionPlans?.length || 4,
        },
      };
    },
    isBackoffice: function () {
      return isBackofficeRole(this.user?.user?.user_role_id);
    },
  },
  watch: {
    externalParcels: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val) return;
        this.syncFromExternalParcels(val);
      }
    },
    proposalPercentages: {
      deep: true,
      handler(newVal) {
        // Sincroniza do store para as variáveis locais (quando outro componente atualiza)
        if (newVal.investmentPercentage !== undefined && newVal.investmentPercentage !== this.investmentPercentage) {
          this.investmentPercentage = newVal.investmentPercentage;
        }
        if (newVal.discountPercentage !== undefined && newVal.discountPercentage !== this.discountPercentage) {
          this.discountPercentage = newVal.discountPercentage;
        }
        if (newVal.additionPercentage !== undefined && newVal.additionPercentage !== this.additionPercentage) {
          this.additionPercentage = newVal.additionPercentage;
        }
        if (newVal.recommendationDiscount !== undefined && newVal.recommendationDiscount !== this.recommendationDiscount) {
          this.recommendationDiscount = newVal.recommendationDiscount;
        }
      },
    },
    subscriptionPlanId(newVal) {
      if (
        [subscriptionPlanTypes.FLUXO, subscriptionPlanTypes.APP].includes(
          newVal
        )
      ) {
        this.servicesToContract = this.onlySubscriptionKey;
      } else if (this.servicesToContract === this.onlySubscriptionKey) {
        this.servicesToContract = "consulting_and_subscription";
      }
      if (newVal === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM && this.premiumAmount > 0) {
        this.$nextTick(() => {
          this.premiumAmountInput = floatToMoney(this.premiumAmount);
        });
      }
      this.preSave();
    },
    isOnlyConsulting(newVal, oldVal) {
      if (!newVal && oldVal && this.subscriptionPlanId === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM && this.premiumAmount > 0) {
        this.$nextTick(() => {
          this.premiumAmountInput = floatToMoney(this.premiumAmount);
        });
      }
    },
    async subscriptionPlansVisible(val) {
      if (val && !this.loading) {
        await this.syncCarouselToSelectedPlan();
      }
    },
    canEnablePartnerAsSigner(newValue) {
      if (newValue || !this.partnerAsSigner) return;

      this.partnerAsSigner = false;
      this.preSave();
    },
    closerConsultantId(val) {
      this.$emit('closer-consultant-change', {
        supportFromAnotherConsultant: this.supportFromAnotherConsultant,
        closerConsultantId: val,
      });
    },
    supportFromAnotherConsultant(val) {
      this.$emit('closer-consultant-change', {
        supportFromAnotherConsultant: val,
        closerConsultantId: this.closerConsultantId,
      });
    },
  },
  async mounted() {
    if (this.isAnalyst && this.supportFromAnotherConsultant === "no") {
      this.supportFromAnotherConsultant = "yes";
    }
    this.token = this.$route.params.customerId;
    await this.fetchAll();
  },
  methods: {
    ...mapActions({
      getProposalContractServiceTypes: types.GET_CONTRACT_SERVICE_TYPES,
      getProposalPaymentMethodTypes: types.GET_PAYMENT_METHOD_TYPES,
      getSpecialistConsultants: types.GET_CLOSER_CONSULTANTS,
      getProposal: types.GET_PROPOSAL,
      getContracts: types.GET_CUSTOMER_CONTRACTS,
      getCustomerInfo: types.GET_CUSTOMER_INFO,
      getSubscriptionPlans: types.GET_SUBSCRIPTION_PLANS,
      getCustomerSubscriptionPlans: types.GET_CUSTOMER_SUBSCRIPTION_PLANS,
      autoSaveProposal: types.AUTO_SAVE_PROPOSAL,
      calculateProposal: types.CALCULATE_PROPOSAL,
      autoSaveRecommendation: types.AUTO_SAVE_RECOMMENDATION,
      deleteRecommendation: types.DELETE_RECOMMENDATION,
      checkDuplicateCellPhoneClient: sharedTypes.CHECK_DUPLICATE_CUSTOMER_PHONE,
      checkDuplicateCellPhonePn: sharedTypes.CHECK_DUPLICATE_CONSULTANT_PHONE,
      checkDuplicateLeadCustomerPhone:
        sharedTypes.CHECK_DUPLICATE_LEAD_CUSTOMER_PHONE,
    }),
    ...mapMutations({
      mutateProposal: types.MUTATE_PROPOSAL,
      changeLoadingState: types.MUTATE_INTERVIEW_PROPOSAL_LOADING,
      setProposalPercentages: types.MUTATE_PROPOSAL_PERCENTAGES,
    }),
    async fetchProposal() {
      this.loading = true;
      try {
        const response = await this.getProposal(this.$route.params.customerId);
        const {
          installment_quantity,
          services_to_contract,
          payment_method,
          closer_consultant_id,
          interest,
          total_amount,
          installment_amount,
          discount,
          recommendation_discount,
          recommendations,
          subscription_plan_id,
          subscription_amount: saved_subscription_amount,
          partner_as_signer,
          investment_percentage,
          discount_percentage,
          addition_percentage,
        } = response.data;
        this.setProposalPercentages({
          investmentPercentage: floatToPercentage(investment_percentage),
          discountPercentage: floatToPercentage(discount_percentage),
          additionPercentage: floatToPercentage(addition_percentage),
          recommendationDiscount: recommendation_discount || 0,
        });
        this.selectedParcel =
          installment_quantity > 1 ? installment_quantity : 12;
        this.servicesToContract =
          services_to_contract || "consulting_and_subscription";
        this.paymentMethod = payment_method;
        this.interest = interest;
        this.totalAmount = total_amount;
        this.installmentAmount = installment_amount;
        this.discount = discount;
        this.recommendationDiscount = recommendation_discount || 0;
        this.subscriptionPlanId = subscription_plan_id;
        // Restaurar valor do Premium salvo na proposta (persistência entre sessões)
        const savedPremiumAmount = parseFloat(saved_subscription_amount) || 0;
        if (subscription_plan_id === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM && savedPremiumAmount > 0) {
          this.premiumAmount = savedPremiumAmount;
          this.premiumAmountInput = floatToMoney(savedPremiumAmount);
        } else {
          this.premiumAmount = 0;
          this.premiumAmountInput = "";
        }
        this.partnerAsSigner = Boolean(partner_as_signer);
        if (
          [subscriptionPlanTypes.FLUXO, subscriptionPlanTypes.APP].includes(
            this.subscriptionPlanId
          )
        ) {
          this.servicesToContract = this.onlySubscriptionKey;
        }
        this.recommendations = recommendations.map((recommendation) => {
          const {
            id,
            name,
            cell_phone,
            email,
            occupation,
            goal,
            comment,
            type,
            customer_id,
          } = recommendation;
          return {
            id,
            name,
            cellPhone: cell_phone,
            email,
            occupation,
            goal,
            comment,
            type,
            customer_id,
            duplicateError: false,
            duplicateMessage: "",
          };
        });
        const customerInfoResponse = await this.getCustomerInfo(
          this.$route.params.customerId
        );
        const hasPartner = Boolean(customerInfoResponse.data?.has_partner);
        const hasPartnerName = Boolean(customerInfoResponse.data?.partner_name);
        const hasPartnerEmail = Boolean(customerInfoResponse.data?.partner_email);
        this.hasPartnerInfoForSignature =
          hasPartner && hasPartnerName && hasPartnerEmail;
        if (!this.hasPartnerInfoForSignature) {
          this.partnerAsSigner = false;
        }
        this.consultantId = customerInfoResponse.data?.consultant_id;
        this.userConsultantId = this.user?.user?.appify_consultant_id;
        this.ownerLevel = customerInfoResponse.data?.customer_consultant?.id_consultant_role;

        if (
          this.isAnalyst ||
          closer_consultant_id ||
          this.differentConsultant
        ) {
          this.supportFromAnotherConsultant = "yes";
        } else {
          this.supportFromAnotherConsultant = "no";
        }

        if (closer_consultant_id) {
          this.closerConsultantId = closer_consultant_id;
        } else if (this.differentConsultant) {
          this.closerConsultantId = this.userConsultantId;
        }

        this.changeParcelsQuantity(installment_quantity);
        const payload = getProposalPayload(this);
        this.mutateProposal(payload);
      } catch (error) {
        this.$vfm.show("message", {
          type: "error",
          messages: [
            "Não foi possível obter a proposta do cliente.",
            "Entre em contato com o time de TI antes de prosseguir com a operação.",
          ],
        });
      } finally {
        this.loading = false;
        this.changeLoadingState(false);
      }
    },
    async fetchAll() {
      this.changeLoadingState(true);
      try {
        await Promise.all([
          this.fetchProposal(),
          this.getProposalContractServiceTypes(),
          this.getProposalPaymentMethodTypes(),
          this.getSpecialistConsultants(),
          this.getSubscriptionPlans(),
          this.getCustomerSubscriptionPlans(this.token),
        ]);

        if (this.isInterview) {
          await this.getContracts(this.token);
        }
      } catch (error) {
        console.error("Error in fetchAll:", error);
      } finally {
        this.changeLoadingState(false);
        // Aguarda o Vue executar os watchers enfileirados durante o fetch antes de
        // liberar o preSave, evitando sobrescrever subscription_amount com null.
        await this.$nextTick();
        this.isInitializing = false;
        this.calculate();
      }
    },
    addRecommendation(leadType) {
      this.recommendations.push({
        id: "",
        name: "",
        cellPhone: "",
        email: "",
        occupation: "",
        goal: "",
        comment: "",
        type: leadType,
        duplicateError: false,
        duplicateMessage: "",
      });
    },

    async checkCellPhone(rec, index) {
      const trimmed = (rec.cellPhone || "").replace("+", "").replaceAll(" ", "");
      if (trimmed.length < 13) {
        rec.duplicateError = false;
        rec.duplicateMessage = "";
        return;
      }
      const seq = (rec._checkSeq = (rec._checkSeq || 0) + 1);

      const inFormDup = this.recommendations.some(
        (other, i) =>
          i !== index && (other.cellPhone || "").replace(/\D/g, "") === trimmed
      );
      if (inFormDup) {
        rec.duplicateError = true;
        rec.duplicateMessage =
          "Este telefone já foi informado em outra recomendação.";
        this.$vfm.show("message", {
          type: "error",
          messages: [rec.duplicateMessage],
        });
        return;
      }

      const check = (async () => {
        try {
          if (rec.type === "PCL") {
            // Mesma regra da tela de criação de Lead/Cliente (leads PCL);
            // exclui a própria recomendação quando já salva
            await this.checkDuplicateLeadCustomerPhone({
              phone: trimmed,
              customerId: rec.customer_id,
            });
            // Clientes plenos — sem parâmetro de exclusão: o backend exclui
            // linhas com customer_reference NULL quando ele é passado, e uma
            // rec salva vira Customer type LEAD (este check só olha CUSTOMER)
            await this.checkDuplicateCellPhoneClient({ phone: trimmed });
          }
          if (rec.type === "PPN") {
            await this.checkDuplicateCellPhonePn({
              cell: trimmed,
              id: rec.customer_id,
            });
          }
          if (rec._checkSeq === seq) {
            rec.duplicateError = false;
            rec.duplicateMessage = "";
          }
        } catch (error) {
          if (rec._checkSeq !== seq) return;
          rec.duplicateError = true;
          rec.duplicateMessage =
            error?.response?.data?.message ||
            "Já existe um cliente/lead com este telefone.";
          this.$vfm.show("message", {
            type: "error",
            messages: [rec.duplicateMessage],
          });
        }
      })();

      this.pendingPhoneChecks.push(check);
      check.finally(() => {
        this.pendingPhoneChecks = this.pendingPhoneChecks.filter(
          (p) => p !== check
        );
      });
      return check;
    },

    async removeRecommendation(id) {
      this.loadingProposal = true;
      this.deleteRecommendation(id)
        .then((response) => {
          this.fetchProposal();
        })
        .catch((error) => {
          this.$vfm.show("message", {
            type: "error",
            messages: [
              `${error?.response?.data?.message}.` ||
                "Não foi possível excluir a recomendação.",
              "Entre em contato com o time de TI antes de prosseguir com a operação.",
            ],
          });
        })
        .finally(() => {
          this.loadingProposal = false;
        });
    },
    removeRecWhenFieldsEmpty(i) {
      this.recommendations.splice(i, 1);
    },
    preSave() {
      // Skip auto-save during initial data load to prevent race conditions
      if (this.isInitializing) {
        return;
      }

      // Atualiza o store com os valores locais
      this.setProposalPercentages({
        investmentPercentage: this.investmentPercentage,
        discountPercentage: this.discountPercentage,
        additionPercentage: this.additionPercentage,
        recommendationDiscount: this.recommendationDiscount,
      });

      const payload = getProposalPayload({
        ...this,
        investmentPercentage: this.investmentPercentage,
        discountPercentage: this.discountPercentage,
        additionPercentage: this.additionPercentage,
        recommendationDiscount: this.recommendationDiscount,
      });
      const currentPayload = JSON.stringify(payload);
      if (this.tempPayload !== currentPayload) {
        this.tempPayload = currentPayload;
        this.mutateProposal(payload);
        this.autoSave(payload);
      }
    },
    async autoSave(payload) {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.autoSaveProposal(payload)
        .then((response) => {
          this.calculate();
        })
        .catch((error) => {
          this.$vfm.show("message", {
            type: "error",
            messages: [
              "Não foi possível salvar automaticamente a proposta do cliente.",
              "Entre em contato com o time de TI antes de prosseguir com a operação.",
            ],
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async autoSaveRecommendations() {
      // Skip auto-save during initial data load to prevent race conditions
      if (this.isInitializing) {
        return;
      }

      this.loading = true;

      // Aguarda checagens de telefone em voo (input dispara o check
      // assíncrono; blur dispara o save logo em seguida)
      if (this.pendingPhoneChecks.length) {
        await Promise.allSettled(this.pendingPhoneChecks);
      }

      const duplicate = this.recommendations.find((rec) => rec.duplicateError);
      if (duplicate) {
        this.v$.recommendations.$touch();
        this.loading = false;
        this.loadingRecs = false;
        this.loadingProposal = false;
        this.$vfm.show("message", {
          type: "error",
          messages: [
            duplicate.duplicateMessage ||
              "Já existe um cliente/lead com este telefone.",
            "As recomendações não foram salvas.",
          ],
        });
        return;
      }

      if (this.v$.recommendations.$error) {
        this.loading = false;
        this.loadingRecs = false;
        this.loadingProposal = false;
        return;
      }
      const payload = getProposalPayload(this);
      const currentPayload = JSON.stringify(payload);

      if (this.tempPayload !== currentPayload) {
        this.tempPayload = currentPayload;
        this.mutateProposal(payload);
      }

      try {
        this.loadingRecs = true;
        this.loadingProposal = true;
        await this.autoSaveRecommendation({
          token: payload.token,
          recommendations: payload.recommendations,
        });
        const hasEmptyIds = payload.recommendations.some(
          (recommendation) => !recommendation.id
        );
        if (hasEmptyIds) {
          this.loadingRecs = true;
          const response = await this.getProposal(
            this.$route.params.customerId
          );
          if (response?.data?.recommendations) {
            const { recommendations } = response.data;
            this.recommendations = recommendations.map((recommendation) => {
              const {
                id,
                name,
                cell_phone,
                email,
                occupation,
                goal,
                comment,
                customer_id,
                type,
              } = recommendation;
              return {
                id,
                name,
                cellPhone: cell_phone,
                email,
                occupation,
                goal,
                comment,
                customer_id,
                type,
                duplicateError: false,
                duplicateMessage: "",
              };
            });
          }
        }
        this.calculate();
      } catch (error) {
        if (error.response.status === 406) {
          this.$vfm.show("message", {
            type: "error",
            messages: ["Celular já existente em nosso banco de dados."],
          });
        } else {
          this.$vfm.show("message", {
            type: "error",
            messages: [
              "Não foi possível salvar automaticamente as recomendações do cliente.",
              "Entre em contato com o time de TI antes de prosseguir com a operação.",
            ],
          });
        }
      } finally {
        this.loading = false;
        this.loadingRecs = false;
        this.loadingProposal = false;
      }
    },

    async saveRecommendation() {
      this.loadingProposal = true;
      this.fetchProposal()
        .catch((error) => {
          this.$vfm.show("message", {
            type: "error",
            messages: [
              "Não foi possível salvar a recomendação.",
              "Entre em contato com o time de TI antes de prosseguir com a operação.",
            ],
          });
        })
        .finally(() => {
          this.loadingProposal = false;
        });
    },
    onChangeParcels(event) {
      this.changeParcelsQuantity(event.target.value);
    },
    syncFromExternalParcels({ parcelsQuantity, selectedParcel }) {
      const pq = Number(parcelsQuantity);
      const sp = Number(selectedParcel);
      if (!Number.isNaN(pq)) this.parcelsQuantity = pq;
      if (!Number.isNaN(sp)) this.selectedParcel = sp;
      this.changeParcelsQuantity(pq > 1 ? pq : 1);
    },
    changeParcelsQuantity(value) {
      if (!this.isDetail) {
       const v = Number(value);
       if (this.parcelsQuantity !== v) {
          this.paymentMethod = "credit";
        }
       this.parcelsQuantity = v;
        if (this.calculation?.parcels_values) {
          const parcelValues =
            this.calculation.parcels_values[
             (Number(this.parcelsQuantity) - 1).toString()
            ];
          this.interest = parcelValues.interest;
          this.totalAmount = parcelValues.total_amount;
          this.installmentAmount = parcelValues.installment_amount;
          this.discount = parcelValues.discount;
          this.preSave();
        }
      }
    },
    calculate() {
      this.loading = true;
      this.calculateProposal(this.token)
        .catch((error) => {
          this.$vfm.show("message", {
            type: "error",
            messages: [
              "Não foi possível obter os dados de proposta do cliente.",
              "Entre em contato com o time de TI antes de prosseguir com a operação.",
            ],
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async setRecommendationDiscount(value, active) {
      if (typeof active === "undefined") {
        this.$vfm.show("message", {
          type: "error",
          messages: ["Por favor espere o carregamento dos dados"],
        });
        return false;
      }

      if (active === false) {
        this.$vfm.show("message", {
          type: "error",
          messages: [
            "Esse Desconto não está disponível devido ao valor minimo da EP",
          ],
        });
        return false;
      } else {
        const isFormCorrect = await this.v$.$validate();
        if (!isFormCorrect) return;
        if (!this.isDetail && value !== this.recommendationDiscount) {
          this.recommendationDiscount = value;
          this.changeParcelsQuantity(this.parcelsQuantity);
        }
      }
    },
    async syncCarouselToSelectedPlan() {
      if (!this.subscriptionPlansVisible) return;
      await this.$nextTick();
      const idx = this.planPages.findIndex((page) =>
        page.some((p) => p.id === this.subscriptionPlanId)
      );
      if (idx >= 0) {
        this.currentPlanPage = idx;
      }
    },
    setSubscription(plan) {
      if (!this.isDetail) {
        this.subscriptionPlanId = plan.id;

        // Limpa erro e salva. O premiumAmount é preservado para restauração
        // ao voltar para o Premium (Issue 4). O payload só envia subscription_amount
        // quando o plano ativo é Premium (controlado em interview_payloads.js).
        this.premiumAmountError = "";
        this.preSave();
      }
    },
    onPremiumInput() {
      clearTimeout(this.premiumDebounceTimer);
      this.premiumDebounceTimer = setTimeout(() => {
        this.premiumAmountInput = this.$refs.premiumInput?.value ?? '';
        this.applyPremiumAmount();
        this.premiumDebounceTimer = null;
      }, 3000);
    },
    onPremiumBlur() {
      clearTimeout(this.premiumDebounceTimer);
      this.premiumDebounceTimer = null;
      this.premiumAmountInput = this.$refs.premiumInput?.value ?? '';
      this.applyPremiumAmount();
    },
    applyPremiumAmount() {
      const val = moneyToFloat(this.premiumAmountInput);
      if (val < PREMIUM_MINIMUM_AMOUNT) {
        this.premiumAmountError = `O valor mínimo para o Acompanhamento Premium é de R$ 399,90 por mês.`;
        return;
      }
      this.premiumAmountError = "";
      this.premiumAmount = val;
      this.preSave();
    },
    hasPremiumAmountError() {
      return (
        this.subscriptionPlanId === subscriptionPlanTypes.ACOMPANHAMENTO_PREMIUM &&
        !this.isOnlyConsulting &&
        this.premiumAmount < PREMIUM_MINIMUM_AMOUNT
      );
    },
    showPremiumAmountError() {
      this.premiumAmountError = 'O valor mínimo para o Acompanhamento Premium é de R$ 399,90 por mês.';
      this.subscriptionPlansVisible = true;
    },
    isServicesToContractOptionDisabled(key) {
      if (
        [subscriptionPlanTypes.FLUXO, subscriptionPlanTypes.APP].includes(
          this.subscriptionPlanId
        ) &&
        key !== this.onlySubscriptionKey
      ) {
        // If it's a FLUXO plan and the key is not the only subscription key, disable the option
        return true;
      }
      // Otherwise, do not disable the option
      return false;
    },
    openConfimationModal(id) {
      this.$vfm.show(
        {
          component: ConfirmModal,
        },
        {
          messages: [`Deseja excluir <b>${id.name}</b>?`],
          handleConfirm: () => this.removeRecommendation(id),
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.premium-amount-section {
  margin-top: 24px;
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;

  .premium-amount-title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 6px;
  }

  .premium-amount-hint {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 16px;
  }

  .premium-amount-input {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    background: rgba(255, 255, 255, 0.07);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    border-radius: 8px;
    padding: 10px 16px;

    &:focus {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.5);
      color: #fff;
      box-shadow: none;
    }

    &.is-invalid {
      border-color: #dc3545;
    }
  }
}

@media (max-width: 800px) {
  .ribbon {
    padding-right: 295px !important;
  }
}

.container-plans {
  padding: 0 20px !important;
}

.carousel {
  padding: 0 10px !important;
}

.blue-card {
  padding: 30px 20px;
  width: 500px;
  height: 300px;

  h1 {
    font-size: 25px !important;
    font-weight: 600;
    text-align: center;
  }
}

.final-value {
  font-size: 26px !important;
  line-height: 1.2 !important;
  font-weight: 600;
  color: #ffeb98;
}

.recommendation-discount-value {
  display: flex;
  flex-direction: column;
  border-radius: 100px;
  border: solid 1px white;
  padding: 12px;
  color: white;

  &.selected {
    background-color: white;
    color: var(--black-txt);
  }
}

.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  padding-right: 515px;
  padding-bottom: 315px;
}

.ribbon__content {
  left: -50px;
  top: 30px;
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  display: block;
  width: 225px;
  padding: 10px 0;
  background-color: var(--orange);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-align: center;
  border: 2px dotted #fff;
  outline: 5px solid var(--orange);
}

.ribbon::before {
  top: 0;
  left: 0;
  border-top-color: transparent;
  border-right-color: transparent;
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  box-sizing: content-box;
}

.ribbon::after {
  bottom: 0;
  right: 0;
  border-top-color: transparent;
  border-right-color: transparent;
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid #f19066;
}

.subscription-card {
  width: calc(20% - 10px);
  height: 280px;
}

.subscription-ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  padding-right: 290px;
  padding-bottom: 290px;
}

.subscription-ribbon__content {
  left: -2px;
  top: 24px;
  font-size: 0.7em;
  -webkit-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  display: block;
  width: 140px;
  padding: 3px 0;
  background-color: var(--orange);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-align: center;
  border: 2px dotted #fff;
  outline: 5px solid var(--orange);
}

.error-bg {
  background-color: rgba(220, 53, 69, 0.8);
}

.margin-button {
  margin-top: 35px;
}

.recommendation-comment-field {
  min-height: 88px;
  max-height: 180px;
  resize: vertical;
}

@media (max-width: 767.98px) {
  .column-mobile {
    flex-direction: column-reverse;
  }

  .margin-button {
    margin-top: 0px;
  }
}

.disabled {
  // opacity: 0.6;
  // pointer-events: none;
  // color: #ccc;
}

.card-divider {
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 0.3rem 0;
}

.partner-signer-toggle {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  padding: 0.65rem 0.8rem;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  cursor: pointer;
  line-height: 1.35;
}

.partner-signer-column {
  display: flex;
  flex-direction: column;
}

.partner-signer-toggle span {
  flex: 1;
}

.partner-signer-toggle.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.partner-signer-checkbox {
  width: 18px;
  height: 18px;
  margin-top: 0.05rem;
  accent-color: var(--orange);
  flex-shrink: 0;
}

.partner-signer-hint {
  display: block;
  margin-top: 0.45rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.3;
}

option:disabled {
  background-color: #f0f0f0 !important;
  /* Change the background color */
  color: #ccc !important;
  /* Change the text color */
}

.container-plans {
  display: flex;
  justify-content: space-around;
  z-index: 1;

  .card-head-best-choice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ff9d00;
    padding: 0.25rem 1.5rem;
    border-radius: 20px;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    position: relative;
    z-index: 10;

    h5 {
      font-size: 1rem;
      margin-bottom: 0;
    }

    .bg-star {
      width: 30px;
      height: 30px;

      @media (min-width: 1400px) {
        width: 30px;
        height: 30px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .card-title {
      margin-top: 0 !important;
    }
  }

  .selected-plan-card {
    background-color: rgba(55, 117, 190, 0.2) !important;
    border: 3px solid #3775be !important;
    margin-top: 0 !important;
    box-shadow: 0 0 20px rgba(55, 117, 190, 0.4) !important;
    transform: scale(1.02) !important;
    transition: all 0.3s ease !important;
    position: relative;
    z-index: 5;
  }

  .card-plans {
    width: 100%;
    max-width: 340px;
    background-color: rgba(24, 29, 47, 0.85);
    padding: 1.5rem;
    border-radius: 20px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-right: 1rem;
    min-height: 600px;
    transition: all 0.3s ease;
    border: 2px solid transparent;

    @media (min-width: 1400px) {
      width: 230px;
      padding: 1rem;
    }

    &:last-child {
      margin-right: 0;
    }

    &.clickable:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
    }

    .card-head-best-choice,
    .card-title,
    .card-price {
      margin-bottom: 1.25rem;
    }

    .card-title {
      margin-top: 1rem;
      min-height: 52px;
      margin-bottom: 0;

      .card-font {
        font-size: 1.45em !important;
        text-align: start;
      }
    }

    .card-subtitle {
      font-size: 0.9em;
      color: #dfecff;
      padding-bottom: 1rem;

      @media (min-width: 1400px) {
        font-size: 0.85em;
      }
    }

    .card-price {
      h1 {
        display: flex;
        align-items: baseline;
        font-size: 1.7em;

        p {
          color: #dfecff;
          font-weight: normal;
          font-size: 0.85em;
          margin-bottom: 0;
        }
      }
    }

    .card-description {
      .card-detail {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;

        &:last-child {
          margin-bottom: 0;
        }

        background-color: rgba(255, 255, 255, 0.2);
        padding: 0.5rem 1rem;
        border-radius: 80px;

        img {
          width: 25px;
          height: 25px;
          margin-right: 0.75rem;

          @media (min-width: 1400px) {
            width: 17px;
            height: 17px;
          }
        }

        span {
          @media (min-width: 1400px) {
            font-size: 0.85em;
          }
        }
      }

      .not-included {
        opacity: 0.6;
      }
    }
  }
}

.card-title .card-font {
  @media (min-width: 1400px) {
    font-size: 1.25em !important;
  }
}

.card-price {
  .card-font {
    @media (min-width: 1400px) {
      font-size: 1.45em !important;
    }
  }
}

.best-choice-border {
  border: 3px solid #ff9d00;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  margin-top: 0 !important;
}

.plans-pager {
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 0.5rem;
}

.plans-page-track {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
  min-width: 0;
  gap: 1.45rem;
}

.plan-nav-arrow {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-bottom: 260px;
  border-radius: 50%;
  border: 1px solid white;
  background-color: transparent;
  color: white;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
}

.plans-page-dots {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 0.5rem;
  margin-top: 1rem;
}

.plan-page-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid white;
  background-color: transparent;
  padding: 0;
  cursor: pointer;

  &.active {
    background-color: white;
  }
}

@media (max-width: 767.98px) {
  .plan-nav-arrow {
    margin-bottom: 0;
    align-self: center;
  }
}

// .slider {
//   position: absolute;
//   cursor: pointer;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: #ccc;
//   transition: 0.4s;
//   border-radius: 24px;
// }

// .slider:before {
//   position: absolute;
//   content: "";
//   height: 18px;
//   width: 18px;
//   left: 4px;
//   bottom: 3px;
//   background-color: white;
//   transition: 0.4s;
//   border-radius: 50%;
// }
</style>
